import React from 'react';
import { Section } from './ui/Section';
import { X } from 'lucide-react';
export function WhyFailedSection() {
  const failures = [{
    title: 'Cursos de trading / cripto',
    desc: 'Funcionan… para gente con capital y estómago para perder dinero. Para ti solo fueron una nueva humillación.'
  }, {
    title: 'Negocios online milagro',
    desc: 'Dropshipping, Amazon, afiliados, IA. Todo requiere dinero, foco y tiempo que no tienes.'
  }, {
    title: 'Motivación y mentalidad',
    desc: 'Te hicieron sentir bien 48 horas. Luego volviste a tu vida de siempre.'
  }, {
    title: 'Ideas sueltas',
    desc: 'Nunca tuviste un sistema diario. Solo intentos aislados.'
  }];
  return <Section className="bg-gray-50" data-id="element-163">
      <h2 className="text-4xl md:text-6xl font-bold mb-16 text-center uppercase" data-id="element-164">
        Por qué lo que probaste falló
      </h2>

      <div className="grid md:grid-cols-2 gap-8" data-id="element-165">
        {failures.map((item, idx) => <div key={idx} className="bg-white border-2 border-black p-8 hover:shadow-brutal transition-all" data-id="element-166">
            <div className="flex items-start justify-between mb-4" data-id="element-167">
              <h3 className="text-2xl font-bold uppercase" data-id="element-168">{item.title}</h3>
              <X className="w-8 h-8 text-red-600" data-id="element-169" />
            </div>
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-170">{item.desc}</p>
          </div>)}
      </div>
    </Section>;
}